import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { StateStorageService } from '../../shared/auth/state-storage.service';
import { AuthServerProvider } from '../../shared/auth/auth-jwt.service';
import { FileUploader } from 'ng2-file-upload';

import { School } from './school.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

@Injectable()
export class SchoolService  extends AbstractEntityService {

    protected resourceUrl = 'api/schools';
    private resourceNoAuthUrl = 'api/no-auth/schools';
    private resourceSearchUrl = 'api/_search/schools';
    private resourceSearchNoAuthUrl = 'api/no-auth/_search/schools';
    protected resourceCountUrl = 'api/_search/count/schools';

    static readonly  ERROR_COLOR: string = 'dd7366';
    static readonly  DEFAULT_NAVBAR_COLOR: string = 'f2efe8';
    static readonly  DEFAULT_FOOTER_COLOR: string = '1A2A09';
    static readonly  DEFAULT_BACKGROUND_COLOR: string = 'ffffff';

    constructor(protected http: HttpClient,
                private stateStorageService: StateStorageService,
                private authServerProvider: AuthServerProvider,
                private dateUtils: DateUtils) {
                    super(http);
    }

    create(school: School): Observable<School> {
       let copy: School = Object.assign({}, school);
       if (school.subscriptionEndDate instanceof Date) {
           copy.subscriptionEndDate = school.subscriptionEndDate;
       } else {
           copy.subscriptionEndDate = this.dateUtils.toDate(school.subscriptionEndDate);
        }
        return this.http.post<School>(this.resourceUrl, copy).map((res: School) => {
            return res;
        });
    }

    update(school: School): Observable<School> {
        let copy: School = Object.assign({}, school);
        return this.http.put<School>(this.resourceUrl, copy).map((res: School) => {
            return res;
        });
    }

    updateCurrent(school: School): Observable<School> {
        let copy: School = Object.assign({}, school);
        return this.http.put<School>(this.resourceUrl + '/current', copy).map((res: School) => {
            return res;
        });
    }

    getNewUploader(): FileUploader {
        return new FileUploader({
            url: this.resourceUrl + '/current/homeimage',
            method : 'PUT',
            authToken : 'Bearer ' + this.authServerProvider.getToken()
        });
    }

    find(id: number): Observable<School> {
        return this.http.get<School>(`${this.resourceUrl}/${id}`).map((res: School) => {
            let jsonResponse = res;
            jsonResponse.subscriptionEndDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.subscriptionEndDate);
            return jsonResponse;
        });
    }

    findCurrent(): Observable<School> {
        return this.http.get<HttpResponse<School>>(`${this.resourceUrl}/current`)
                        .map((res: any) => {
                            const currentSchool: School = res;
                            currentSchool.subscriptionEndDate = this.dateUtils
                                .convertDateTimeFromServer(currentSchool.subscriptionEndDate);

                            this.stateStorageService.setBackgroundColor(currentSchool.backgroundColor);
                            this.stateStorageService.setNavbarColor(currentSchool.navbarColor);
                            this.stateStorageService.setFooterColor(currentSchool.footerColor);
                            this.stateStorageService.setCurrentTenantName(currentSchool.name);
                            return currentSchool;
                        });
    }

    query(req?: any): Observable<HttpResponse<School[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<School[]>>(this.resourceUrl, options);
    }

    search(req?: any): Observable<HttpResponse<School[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<School[]>>(this.resourceSearchUrl, options);
    }

    searchNoAuth(req?: any): Observable<HttpResponse<School[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<School[]>>(this.resourceSearchNoAuthUrl, options);
    }

    getColor(field: string) {
        let color: string;
        switch (field) {
            case 'navbar':
                color = this.stateStorageService.getNavbarColor();
                return color ?
                    '#' + color :
                    '#' + SchoolService.DEFAULT_NAVBAR_COLOR;
            case 'footer':
                color = this.stateStorageService.getFooterColor();
                return color ?
                    '#' + color :
                    '#' + SchoolService.DEFAULT_FOOTER_COLOR;
            case 'background':
                color = this.stateStorageService.getBackgroundColor();
                return color ?
                    '#' + color :
                    '#' + SchoolService.DEFAULT_BACKGROUND_COLOR;
            default:
                return '#' + SchoolService.ERROR_COLOR;
        }
    }

    getCurrentTenantName() {
        let name: string = this.stateStorageService.getCurrentTenantName();
        return name ? name : 'jYogui';
    }

    public getAgendaUrl(school: School): string {
        const baseUrl = window.location.origin;
        const path = '/#/lesson-public/school/';
        return school && school.id ? `${baseUrl}${path}${school.id}` : `${baseUrl}${path}`;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school/school.service.ts